<template>
  <div>
    <Card>
      <ui-tabs :tabs="tabs">
        <template #content-first>
          <div>First tab</div>
        </template>
        <template #content-second>
          <div>Second tab</div>
        </template>
      </ui-tabs>
    </Card>
  </div>
</template>

<script setup lang="ts">
import Card from '@/stories/utils/card.vue';

const tabs = [
  {
    label: 'First tab',
    key: 'first',
    icon: 'fas fa-list',
  },
  {
    label: 'Second tab',
    key: 'second',
    icon: 'fas fa-pen',
  },
];
</script>
